import axios from 'axios';
import PageErrors from '@js/src/PageErrors';

require('./event-polyfill');
require('./extensions');

// Initialize page errors component
PageErrors.initialize();

// Setup axios
let csrf = document.head.querySelector('meta[name="csrf-token"]').content;
axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-Csrf-Token': csrf,
};
